export interface Faq {
  id: string;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: 'f1',
    question: '什么是正版韩漫？为什么要看正版？',
    answer:
      '正版韩漫是指已获得作者与版权方正式授权、在官方渠道发布的韩漫作品。选择正版渠道，既能获得稳定高清的画质与流畅的翻译，也是尊重创作者、支持行业健康发展的重要方式。',
  },
  {
    id: 'f2',
    question: '如何确认一个平台是正版授权渠道？',
    answer:
      '可通过三点判断：一看平台是否公开标注“官方授权”或“正版”标识；二看平台页脚是否披露版权方或授权关系；三看作品是否提供官方章节编号、稳定更新与付费说明。正版韩漫大全仅收录具备明确授权关系的官方平台。',
  },
  {
    id: 'f3',
    question: '正版韩漫和盗版站有什么区别？',
    answer:
      '正版韩漫画质清晰、翻译准确、更新稳定，并有明确的付费与版权声明；盗版站则常出现画质模糊、章节错乱、弹窗广告泛滥等问题，还可能附带恶意软件与隐私风险，且并未获得任何授权。',
  },
  {
    id: 'f4',
    question: '在官方渠道追更是否需要付费？',
    answer:
      '多数正版平台提供免费试读章节，后续章节可选择单话购买或开通会员畅读。具体付费规则因平台与作品而异，在官方页面都会有清晰说明，读者可按需选择。',
  },
  {
    id: 'f5',
    question: '韩漫的分类有哪些？',
    answer:
      '常见分类包括恋爱都市、奇幻冒险、悬疑惊悚、校园青春、动作武侠与日常治愈等。正版韩漫大全的官方分类页已经为你整理好各类型下的正版作品入口，方便按兴趣浏览。',
  },
  {
    id: 'f6',
    question: '如何在手机和电脑上访问官方入口？',
    answer:
      '大部分正版平台同时提供网页端与官方 APP，支持手机、平板和电脑多端同步阅读。你可以在正版韩漫大全的官方入口区域直达各平台官网，再根据提示下载对应应用即可。',
  },
];